<template>
  <div class="hm-home">
    <el-card>
      <div class="panel flex item-center flex-between">
        <div class="button-wrapper mr10">
          <el-button size="small" type="primary" @click="toAdd"
            >添加优惠券</el-button
          >
        </div>
        <div class="form-wrapper flex flex-1 flex-wrap flex-end">
          <el-select
            size="small"
            clearable
            filterable
            placeholder="使用平台"
            v-model="sysTag"
            style="width: 150px"
            class="mr10"
          >
            <el-option label="禾苗主系统" :value="0"></el-option>
            <!-- <el-option label="服务系统" :value="1"></el-option> -->
          </el-select>
          <el-select
            size="small"
            clearable
            filterable
            placeholder="选择券类型"
            v-model="type"
            style="width: 150px"
            class="mr10"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            size="small"
            clearable
            filterable
            placeholder="选择会员类型"
            v-model="isPlus"
            style="width: 150px"
            class="mr10"
          >
            <el-option
              v-for="item in members"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            size="small"
            clearable
            filterable
            placeholder="选择商品渠道"
            v-model="useRank"
            style="width: 150px"
            class="mr10"
          >
            <el-option label="通用渠道" value="0"></el-option>
            <el-option label="微店" value="1"></el-option>
            <el-option label="门店" value="2"></el-option>
          </el-select>
          <el-select
            size="small"
            clearable
            filterable
            placeholder="选择券墙分类"
            v-model="label"
            style="width: 150px"
            class="mr10"
          >
            <el-option
              v-for="item in tabList"
              :key="item.id"
              :label="item.labelName"
              :value="item.couponLabelId"
            ></el-option>
          </el-select>
          <el-date-picker
            class="mr10"
            size="small"
            style="width: 250px"
            value-format="yyyy-MM-dd"
            v-model="ruleValidDate"
            placeholder="选择时间"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
          <el-input
            class="mr10"
            size="small"
            clearable
            placeholder="输入券名/标签/券编码"
            v-model.trim="name"
            style="width: 150px"
          ></el-input>
          <el-button
            size="small"
            style="margin-right: 0px;"
            @click="reset"
            class="hmicon icon-zhongzhi reset"
            :disabled="
              this.type === '' && this.ruleValidDate === [] && this.name === ''
            "
          ></el-button>
          <el-button size="small" type="primary" @click="search"
            >查询</el-button
          >
        </div>
      </div>
      <div class="table">
        <div class="flex table-panel">
          <span
            class="btn"
            :class="{ active: activeTab === v.index }"
            @click="switchTab(v.index)"
            v-for="(v, i) in btnList"
            :key="i"
            >{{ v.name }}</span
          >
        </div>
        <div>
          <el-table border :data="allRules" style="width: 100%">
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              width="50"
              label="序号"
              :index="index => index + (currentPage - 1) * pageSize + 1"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="name"
              label="名称"
            ></el-table-column>
            <el-table-column
              v-if="couponLevelList.length"
              header-align="center"
              align="center"
              prop="couponLevelName"
              label="优惠券层级"
            >
              <template slot-scope="scope">
                {{ scope.row.couponLevelName }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="type"
              label="优惠券类型"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.type === 0">
                  满减券
                </div>
                <div v-else-if="scope.row.type === 1">
                  兑换券
                </div>
                <div v-else-if="scope.row.type === 2">
                  运费券
                </div>
                <div v-else-if="scope.row.type === 3">
                  折扣券
                </div>
                <div v-else-if="scope.row.type === 4">
                  服务券
                </div>
                <div v-else-if="scope.row.type === 5">
                  满量券
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="levelMin"
              label="使用门槛"
            >
              <template slot-scope="scope">
                {{ scope.row.levelMin }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="account"
              label="减免金额"
            >
              <template slot-scope="scope">
                {{ scope.row.account }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="discount"
              label="折扣（折）"
            >
              <template slot-scope="scope">
                {{ scope.row.discount }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="有效期"
              width="200"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.useImmediately !== 1">
                  <el-button
                    size="small"
                    type="text"
                    @click="getRuleTime(scope.row.ruleId)"
                    v-if="
                      !scope.row.useInTime &&
                        scope.row.validTime &&
                        scope.row.ruleTimeStrategyType !== 4
                    "
                    >{{ scope.row.validTime }}</el-button
                  >
                  <span v-if="scope.row.useInTime">{{
                    scope.row.useInTime
                  }}</span>
                  <span
                    v-else-if="scope.row.ruleTimeStrategyType === 4"
                    style="font-size: 12px;"
                  >
                    {{
                      `${scope.row.ruleStartDate} ${
                        scope.row.ruleStartTime.split(",")[0]
                      }`
                    }}
                    <br />
                    至{{
                      `${scope.row.ruleEndDate} ${
                        scope.row.ruleEndTime.split(",")[0]
                      }`
                    }}
                  </span>
                </div>
                <span v-if="scope.row.useImmediately === 1">
                  {{ scope.row.immediatelyEffective }}
                  {{
                    scope.row.immediatelyType === "day" ? "天" : "小时"
                  }}后生效，有效期{{ scope.row.immediatelyEffectiveDays
                  }}{{ scope.row.immediatelyType === "day" ? "天" : "小时" }}
                </span>
              </template>
            </el-table-column>
            <!-- <el-table-column
              header-align="center"
              align="center"
              prop="sysTag"
              label="使用平台"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.sysTag === 0">禾苗主系统</span>
                <span v-if="scope.row.sysTag === 1">服务系统</span>
              </template>
            </el-table-column> -->
            <el-table-column
              header-align="center"
              align="center"
              prop="createTime"
              label="创建时间"
              width="100"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="useRankFormat"
              label="适用范围"
            >
              <template slot-scope="scope">
                {{ scope.row.useRankFormat }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="isPlusFormat"
              label="会员类型"
            >
              <template slot-scope="scope">
                {{ scope.row.isPlusFormat }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="备注"
              prop="readme"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ scope.row.readme }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="statusFormat"
              label="券状态"
            >
              <template slot-scope="scope">
                {{ scope.row.statusFormat }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="offlineTypeCode"
              label="线下券规则编码"
            >
              <template slot-scope="scope">
                <div class="blue" @click="changeOfflineTypeCode(scope.row)" v-if="isShowUpdateOfflineTypeCode">
                  <div v-if="scope.row.offlineTypeCode">{{ scope.row.offlineTypeCode }}</div>
                  <div v-else>点击新增</div>
                </div>
                <div v-else>{{ scope.row.offlineTypeCode }}</div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="labelName"
              label="券墙分类"
            >
              <template slot-scope="scope">
                {{ scope.row.labelName }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="smgLabel"
              show-overflow-tooltip
              label="标签"
            >
              <template slot-scope="scope">
                {{ scope.row.smgLabel }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="createBy"
              show-overflow-tooltip
              label="创建人"
            ></el-table-column>
            <el-table-column
              width="150"
              header-align="center"
              align="center"
              label="操作"
            >
              <template slot-scope="scope">
                <el-button
                  size="small"
                  type="text"
                  @click="
                    edit(
                      scope.row.ruleId,
                      scope.row.type,
                      scope.row.couponStatus,
                      scope.row.useRank
                    )
                  "
                  :disabled="scope.row.status === 2"
                  v-show="
                    activeTab === 0 ||
                      activeTab === 1 ||
                      (activeTab === 4 &&
                        scope.row.statusFormat !== '已过期' &&
                        scope.row.statusFormat !== '已作废')
                  "
                  >编辑</el-button
                >
                <el-button
                  size="small"
                  type="text"
                  @click="
                    copy(
                      scope.row.ruleId,
                      scope.row.type,
                      scope.row.couponStatus,
                      scope.row.useRank
                    )
                  "
                  >查看</el-button
                >
                <!-- :disabled="scope.row.statusFormat === '已作废'">查看</el-button> -->
                <!-- {{scope.row.statusFormat}}
                {{scope.row.status}}
                {{scope.row}} -->

                <el-button
                  size="small"
                  type="text"
                  @click="invalidate(scope.row)"
                  :disabled="scope.row.status === 2"
                  >作废</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="text-center">
        <el-pagination
          background
          layout="total,sizes,  prev, pager, next, jumper"
          :total="allRulesTotal"
          @current-change="paging"
          @size-change="handleSizeChange"
          :current-page="currentPage"
          :page-size="pageSize"
          ref="pagination"
        ></el-pagination>
      </div>
    </el-card>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <el-table border :data="ruleValidTime">
        <el-table-column
          header-align="center"
          align="center"
          prop="ruleStartTime"
          label="起始时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="ruleEndTime"
          label="结束时间"
        ></el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="修改线下券规则编码" :visible.sync="dialogVisibleOfflineTypeCode" width="30%">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        class="demo-ruleForm"
      >
        <el-form-item class="mb10" label="旧线下券规则编码:" prop="oldOfflineTypeCode">
            <el-input
              clearable
              style="width: 250px"
              type="input"
              v-model.trim="ruleForm.oldOfflineTypeCode"
              placeholder="旧线下券规则编码"
              size="small"
              class="ipt mr10"
              :disabled="true"
            ></el-input>
        </el-form-item>
        <el-form-item class="mb10" label="新线下券规则编码:" prop="newOfflineTypeCode">
            <el-input
              clearable
              style="width: 250px"
              type="input"
              v-model.trim="ruleForm.newOfflineTypeCode"
              placeholder="新线下券规则编码"
              size="small"
              class="ipt mr10"
            ></el-input>
        </el-form-item>  
        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="submitForm('ruleForm')"
            >保存</el-button
          >
          <el-button size="small" @click="dialogVisibleOfflineTypeCode = false"
            >取消</el-button
          >
        </div>
      </el-form>
    </el-dialog>  
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../utils/utils";
import { mapGetters } from "vuex";
import { getLoginUser } from "@/utils/auth";

export default {
  data() {
    return {
      label: "",
      currentPage: 1,
      pageSize: 10,
      name: "",
      ruleValidDate: [],
      dialogVisible: false,
      type: "",
      isPlus: "",
      useRank: "",
      sysTag: 0,
      options: [
        { name: "满减券类", value: 0 },
        { name: "兑换券", value: 1 },
        { name: "运费券类", value: 2 },
        { name: "折扣券", value: 3 },
        { name: "服务券", value: 4 },
        { name: "满量券", value: 5 }
      ],
      members: [
        { name: "PLUS会员", value: 0 },
        { name: "全部会员", value: 1 }
      ],
      activeTab: 1,
      btnList: [
        { name: "进行中", active: false, index: 1 },
        { name: "未开始", active: false, index: 0 },
        { name: "已过期", active: false, index: 5 },
        { name: "已作废", active: false, index: 2 },
        { name: "全部", active: true, index: 4 }
      ],
      couponLevelList: [],
      dialogVisibleOfflineTypeCode: false,
      ruleForm:{
        ruleId: "",
        oldOfflineTypeCode: "",
        newOfflineTypeCode: "",
      },
      rules: {
        
      },
      storeCode: "",
      isShowUpdateOfflineTypeCode: false,
    };
  },
  created() {
    this.$store.dispatch("queryTab", {
      labelName: "",
      pageSize: 9999999,
      type: "back"
    });
  },
  mounted() {
    this.getParamValueAllowNull();
    this.getParamsCookie();
    const conditions = getCookie({ key: "conditions" });
    if (conditions) {
      for (let key in conditions) {
        if (this.hasOwnProperty(key)) {
          this[key] = conditions[key];
        }
      }
    }
    this.getAllRules(this.currentPage);
    this.queryCouponLevelList();
  },
  computed: mapGetters([
    "allRules",
    "allRulesTotal",
    "invalidateRulesCode",
    "ruleValidTime",
    "tabList"
  ]),
  watch: {
    invalidateRulesCode(val) {
      if (val === "0") {
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.getAllRules(1);
        this.currentPage = 1;
      }
      this.$store.commit("invalidateRules", "");
    },
    allRules(val) {
      if (this.couponLevelList.length) {
        val.forEach(v => {
          this.couponLevelList.forEach(o => {
            if (v.couponLevel == o.itemValue) {
              v.couponLevelName = o.itemText;
            }
          });
        });
      }
    }
  },
  methods: {
    async queryCouponLevelList() {
      let params = {
        dictCode: "coupon_level"
      };
      const { result } = await this.$store.dispatch(
        "queryCouponLevelList",
        params
      );
      if (result) {
        const { sysDictItem } = result;

        this.couponLevelList = sysDictItem;
      }
    },
    reset() {
      this.type = "";
      this.ruleValidDate = [];
      this.name = "";
      this.isPlus = "";
      this.useRank = "";
    },
    invalidate(v) {
      this.$confirm(
        `
        <div class="message">
          <div>确认将<strong style="color: #f56c6c">${v.name}</strong>作废？</div>
          <div>(注：作废后客户优惠券数据会消失，请慎重操作)</div>
        </div>`,
        "提示",
        {
          dangerouslyUseHTMLString: true
        }
      )
        .then(() => {
          this.$store.dispatch("invalidateRules", {
            ruleId: v.ruleId
          });
          this.setConditions(1);
        })
        .catch(() => {});
    },
    copy(ruleId, index, couponStatus, couponType) {
      this.setConditions(this.currentPage);
      this.$router.push({
        name: "Set",
        query: { type: "copy", ruleId, couponStatus, couponType }
      });
    },
    edit(ruleId, index, couponStatus, couponType) {
      this.setConditions(this.currentPage);
      this.$router.push({
        name: "Set",
        query: { type: "edit", ruleId, couponStatus, couponType }
      });
    },
    switchTab(index) {
      this.activeTab = index;
      this.currentPage = 1;
      this.status = index === 4 ? "" : index;
      this.setConditions(1);
      this.getAllRules(1);
    },
    toAdd() {
      this.setConditions();
      this.$router.push({
        name: "Set",
        query: {
          type: "add"
        }
      });
    },
    search() {
      this.setConditions(1);
      this.getAllRules(1);
      this.currentPage = 1;
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.setConditions(this.currentPage);
      this.getAllRules(this.currentPage);
    },
    paging(page) {
      this.currentPage = page;
      this.setConditions(this.currentPage);
      this.getAllRules(this.currentPage);
    },
    getRuleTime(ruleId) {
      this.$store.dispatch("getRuleValidTime", {
        ruleId
      });
      this.dialogVisible = true;
    },
    getAllRules(currentPage) {
      const startDate =
        this.ruleValidDate && this.ruleValidDate.length > 0
          ? this.ruleValidDate[0]
          : "";
      const endDate =
        this.ruleValidDate && this.ruleValidDate.length > 0
          ? this.ruleValidDate[1]
          : "";
      this.status = this.activeTab === 4 ? "" : this.activeTab;
      this.setParamsCookie();
      this.$store.dispatch("getAllRules", {
        endDate,
        startDate,
        status: this.status,
        type: this.type,
        name: this.name,
        pageNo: currentPage,
        label: this.label,
        isPlus: this.isPlus,
        useRank: this.useRank,
        sysTag: this.sysTag,
        pageSize: this.pageSize
      });
    },
    setParamsCookie() {
      let searchCondition = {
        ruleValidDate: this.ruleValidDate,
        status: this.status,
        type: this.type,
        name: this.name,
        label: this.label,
        isPlus: this.isPlus,
        useRank: this.useRank,
        sysTag: this.sysTag
      };
      setCookie({
        key: "ruleListParams",
        type: "session",
        data: Object.assign({}, searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({ key: "ruleListParams", type: "session" });
      if (prams) {
        this.ruleValidDate = prams.ruleValidDate;
        this.status = prams.status;
        this.type = prams.type;
        this.name = prams.name;
        this.label = prams.label;
        this.isPlus = prams.isPlus;
        this.useRank, (this.sysTag = prams.sysTag);
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    setConditions(currentPage) {
      const startDate =
        this.ruleValidDate && this.ruleValidDate.length > 0
          ? this.ruleValidDate[0]
          : "";
      const endDate =
        this.ruleValidDate && this.ruleValidDate.length > 0
          ? this.ruleValidDate[1]
          : "";
      setCookie({
        key: "conditions",
        data: {
          startDate,
          endDate,
          currentPage,
          status: this.status,
          type: this.type,
          name: this.name,
          label: this.label,
          activeTab: this.activeTab,
          isPlus: this.isPlus,
          useRank: this.useRank
        },
        type: "session"
      });
    },
    changeOfflineTypeCode(row){
      this.ruleForm.ruleId = row.ruleId;
      this.ruleForm.oldOfflineTypeCode = row.offlineTypeCode;
      this.ruleForm.newOfflineTypeCode = "";
      this.dialogVisibleOfflineTypeCode = true;
    },
    submitForm(formName){
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.ruleForm));
          this.$store.dispatch("updateOfflineTypeCode", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: res.result,
                type: "success"
              });
              this.dialogVisibleOfflineTypeCode = false;
              this.search();
            }
          });
        }
      });
    },
    async getParamValueAllowNull() {
      const { code ,result } = await this.$store.dispatch("getParamValueAllowNull", {
        paramCode: "allow_update_offline_type_code"
      })
      if (code === "0") {
        if(result.paramValue && result.paramValue === "yes"){
          this.isShowUpdateOfflineTypeCode = true;
        }
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.btn {
  cursor: pointer;
  font-size: 0.875rem;
  color: #999;
  padding: 8px 20px;
  transition: background 0.1s linear;
}

.btn.active {
  background: #e50065;
  color: #fff;
  border-radius: 5px;
}

.btn.active:hover {
  background: #e50065;
  border-color: #e50065;
}
.table {
  padding: 10px 0;
}
.hidden-over {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.blue{
  cursor: pointer;
}
</style>
